import ReactGA from 'react-ga';
// todo: use segment or more granular analytics: https://stackoverflow.com/questions/49279820/adding-google-analytics-to-react
const isProd = process.env.REACT_APP_STAGE === 'production';

export const trackEvent = (event) => {
  isProd && ReactGA.event(event);
}
